import DgBackToUp from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgBackToUp.install = function (Vue) {
  Vue.component(DgBackToUp.name, DgBackToUp)
}
export default DgBackToUp

export { DgBackToUp }